/* eslint-disable react/prop-types */
import React from 'react';

const OpeningHoursBlock = (hoursCMS) => {
    if (!hoursCMS) return null;

    return hoursCMS.standarizedOpeningHours.map((element, i) => (
        <div key={i}>
            <span className="card__week-days--days">{hoursCMS.weekDay[i]}</span>
            <span className="card__week-days--hours" key={i}>
                {element}
            </span>
        </div>
    ));
};

const ViewOpeningHours = ({ showHours, hoursCMS, PHRASE_TRANSLATIONS, marketLang }) => {
    if (!showHours) return null;

    return (
        <div className="card__all-dates-container">
            <div className="card__week-days"> {OpeningHoursBlock(hoursCMS)}</div>

            {hoursCMS?.holidays?.length > 0 && (
                <>
                    <div className="card__opening-hours">
                        <p className="card__opening-hours-headline">
                            {PHRASE_TRANSLATIONS.holidayHoursHeadLine}
                        </p>

                        {hoursCMS.holidays?.map(
                            ({ description, date, openingTime, closingTime, id }) => {
                                return (
                                    <div className="card__week-days" key={id}>
                                        <div>
                                            <span className="card__week-days--date">
                                                <b>
                                                    {new Intl.DateTimeFormat(marketLang).format(
                                                        new Date(date),
                                                    )}
                                                </b>
                                            </span>
                                            <span className={'card__week-days--hours'}>
                                                {openingTime && closingTime
                                                    ? `${openingTime} - ${closingTime}`
                                                    : PHRASE_TRANSLATIONS.closed}
                                            </span>
                                            <span className="card__week-days--days">
                                                {description}
                                            </span>
                                        </div>
                                    </div>
                                );
                            },
                        )}
                    </div>
                </>
            )}
        </div>
    );
};

export default ViewOpeningHours;
